/** 
 * 暂时不写注释
 */

import nfAlert from './nfAlert.vue'
export default nfAlert